import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const CONTRAT_URL = `${backendUrl}/api/contrat/`;

class ContratService {
	async getAllContrats() {
		try {
			const response = await axios.get(CONTRAT_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getContrat(id) {
		return axios.get(`${CONTRAT_URL}${id}/`);
	}

	createContrat(data) {
		return axios.post(CONTRAT_URL, data).catch((error) => {
			console.error('Erreur lors de la création du contrat', error);
			throw error;
		});
	}

	updateContrat(id, data) {
		return axios.put(`${CONTRAT_URL}${id}/`, data);
	}

	deleteContrat(id) {
		return axios.delete(`${CONTRAT_URL}${id}/`);
	}

	async getContratByPersonnelId(personnelId) {
		try {
			const response = await axios.get(
				`${CONTRAT_URL}?personnel=${personnelId}`
			);
			return response.data;
		} catch (error) {
			console.error('Erreur lors de la récupération du contrat', error);
			throw error;
		}
	}
}

export default new ContratService();
